import { useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { wrapPromise } from "../../../utils/promise";
import { saveRoute } from "../../../store/actions/route";

export default () => {
  const summaryModalRef = useRef();
  const dispatch = useDispatch();
  const onSaveClick = useCallback(async () => {
    return await dispatch(saveRoute());
  }, [dispatch]);

  const openSummaryModal = useCallback(
    ({ isTransfer }) => {
      return wrapPromise(
        summaryModalRef.current.showModal({
          isTransfer,
          onSaveClick,
        })
      );
    },
    [onSaveClick]
  );

  return {
    summaryModalRef,
    openSummaryModal,
  };
};
